import axiosInstance from '../utils/axiosInstance';

const BASE_PATH = '/admin/sales-monthly-targets';

function sanitizeParams(params = {}) {
  const cleaned = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed || trimmed === 'all') {
        return;
      }
      cleaned[key] = trimmed;
      return;
    }
    cleaned[key] = value;
  });
  return cleaned;
}

export async function listMonthlyTargets(params = {}) {
  const response = await axiosInstance.get(BASE_PATH, {
    params: sanitizeParams(params),
  });
  return response.data;
}

export async function getMonthlyTargetOptions() {
  const response = await axiosInstance.get(`${BASE_PATH}/options`);
  return response.data;
}

export async function createMonthlyTarget(payload) {
  const response = await axiosInstance.post(BASE_PATH, payload);
  return response.data;
}

export async function updateMonthlyTarget(id, payload) {
  const response = await axiosInstance.put(`${BASE_PATH}/${id}`, payload);
  return response.data;
}

export async function deleteMonthlyTarget(id) {
  const response = await axiosInstance.delete(`${BASE_PATH}/${id}`);
  return response.data;
}

export async function downloadMonthlyTargetTemplate(params) {
  const response = await axiosInstance.get(`${BASE_PATH}/template`, {
    params: sanitizeParams(params),
    responseType: 'blob',
  });
  return response.data;
}

export async function previewMonthlyTargetTemplate(params) {
  const response = await axiosInstance.get(`${BASE_PATH}/template/preview`, {
    params: sanitizeParams(params),
  });
  return response.data;
}

export async function uploadMonthlyTargets(file) {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axiosInstance.post(`${BASE_PATH}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
}

export default {
  listMonthlyTargets,
  getMonthlyTargetOptions,
  createMonthlyTarget,
  updateMonthlyTarget,
  deleteMonthlyTarget,
  downloadMonthlyTargetTemplate,
  previewMonthlyTargetTemplate,
  uploadMonthlyTargets,
};
